import { createFileRoute } from '@tanstack/react-router'

import ProfilePage from '@/components/pages/backoffice/_profile/containers/ProfilePage'

export const Route = createFileRoute('/_backoffice/profile/')({
  component: ProfilePage
})
